type WordWriteLockHoldListener = () => void;

export class WordWriteLockHolds {
    private writeLockHoldCount = 0;
    private readonly heldStateListeners = new Set<WordWriteLockHoldListener>();

    beginHold(): () => void {
        const wasHeld = this.isHeld();
        this.writeLockHoldCount += 1;
        if (!wasHeld) this.notifyListeners();
        let holdEnded = false;
        return () => {
            if (holdEnded) return;
            holdEnded = true;
            this.writeLockHoldCount -= 1;
            if (!this.isHeld()) this.notifyListeners();
        };
    }

    readonly isHeld = (): boolean => this.writeLockHoldCount > 0;

    readonly subscribe = (listener: WordWriteLockHoldListener): (() => void) => {
        this.heldStateListeners.add(listener);
        return () => {
            this.heldStateListeners.delete(listener);
        };
    };

    private notifyListeners(): void {
        this.heldStateListeners.forEach((listener) => listener());
    }
}

export const wordWriteLockHolds = new WordWriteLockHolds();
